var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",attrs:{"id":"container"}},[_c('div',{staticClass:"main-page"},[_c('div',{staticClass:"message-detail"},[_c('p',{staticClass:"content"},[_vm._v(_vm._s(_vm.messageDetail.content))]),_c('p',{staticClass:"time"},[_vm._v("创建时间："+_vm._s(_vm.messageDetail.create_time))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }